import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type { JetCallReportStatus } from 'pages/Jet/shared/constants/status'

export type JetCallReportItem = {
  associationId: number
  shiftId: number
  workerId: number
  companyId: number
  companyName: string
  timezone: string
  assignmentId: string | null
  startedAt: string | null
  completedAt: string | null
  managerName: string | null
  mealBreakStartedAt: string | null
  mealBreakEndedAt: string | null
  tempLaborId: string | null
  // hasTimesheetPhoto is true for either a worker photo or the
  // auto-generated HyperTrack fallback; timesheetPhotoIsFallback
  // distinguishes the latter.
  hasTimesheetPhoto: boolean
  timesheetPhotoIsFallback: boolean
  syncedAt: string | null
  lastAlertedAt: string | null
  // Computed by the backend - do not re-derive this client-side.
  status: JetCallReportStatus
  // Underlying status, e.g. why a row is `excluded` vs `pending`.
  workStatus: string
  // Call-report submission deadline (shift end + 48h) - do not re-derive.
  reportDeadlineAt: string
}

export type JetCallReportItems = JetCallReportItem[]

export type ListJetCallReportsRequest = {
  page: number
  pageSize: number
  // 0 means no limit ("Forever"); the backend treats it as unbounded.
  daysAgo?: number | null
  statuses?: JetCallReportStatus[] | null
  search?: string[] | null
}

export type ListJetCallReportsResponse = {
  items: JetCallReportItems
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

// Returns CDS work items across the whole JET call-report pipeline.
export const listJetCallReports = async (
  request: ListJetCallReportsRequest
): Promise<ListJetCallReportsResponse> => {
  const params = {
    page: request.page,
    page_size: request.pageSize,
    days_ago: request.daysAgo,
    statuses: request.statuses,
    search: request.search,
  }

  const response = await api.get<ListJetCallReportsResponse>(
    '/admin/jet/call_reports',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
